import { BudgetPeriod } from "@/services/cloudchipr.api";

export const getIsBudgetDataNotCollected = (
  used: number,
  index: number,
  dataLength?: number,
  period?: BudgetPeriod,
) =>
  dataLength !== undefined &&
  index >= dataLength - 2 &&
  used === 0 &&
  period === "daily";
